import React, { useEffect, useState } from 'react';
import { ChatPanels } from '../../../types';
import { CurrentThread } from '../CurrentThread';
import { Threads } from '../Threads';
export var ThreadsPanel = function (_a) {
    var openChat = _a.openChat, userType = _a.userType, channelId = _a.channelId, teamMember = _a.teamMember, migratedToConversation = _a.migratedToConversation, setSelectedThread = _a.setSelectedThread, applicationId = _a.applicationId, onClose = _a.onClose;
    var _b = useState(ChatPanels.Default), activePanel = _b[0], setActivePanel = _b[1];
    useEffect(function () {
        setActivePanel(applicationId ? ChatPanels.CurrentThread : ChatPanels.Threads);
    }, [applicationId]);
    var onSelectThread = function (selectedThread) {
        setSelectedThread({
            userGroupHash: selectedThread.userGroupHash,
            teamMemberIds: selectedThread.teamMembers.map(function (u) { return u.userId; }),
            isMigrated: selectedThread.migratedToConversation,
        });
        setActivePanel(ChatPanels.CurrentThread);
    };
    // no channelId or show history panel
    if (activePanel === ChatPanels.Threads) {
        // load threads
        return (React.createElement(Threads, { channelId: channelId, onSelectThread: onSelectThread, activePanel: activePanel, onClose: onClose }));
    }
    // load channel
    return (React.createElement(CurrentThread, { migratedToConversation: !!migratedToConversation, openChat: openChat, userType: userType, channelId: channelId, teamMember: teamMember, setActivePanel: setActivePanel, onClose: onClose }));
};
//# sourceMappingURL=index.js.map